import { GetWithToken, PostWithToken } from "../../lib/request";

export const getMerchantKeyForAdmin = (storeId) => {
    return async function (dispatch) {
        let url = `/v2/merchant/integration/key?storeId=${storeId}`;
        const result = await GetWithToken(url);
        return result;
    }
}

export const regenerateMerchantKeyForAdmin = (storeId) => {
    return async function (dispatch) {
        let url = `/v2/merchant/integration/key/generate?storeId=${storeId}`;
        const result = await PostWithToken(url, {});
        return result;
    }
}
